module.exports = __webpack_public_path__ + "static/img07__pc-0cfbcf39f6afc5097f3547d191e90f69.svg";